var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "button button--icon",
      class: _vm.buttonClass,
      attrs: { type: "button", disabled: _vm.isDisabled },
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _vm.icon && !_vm.iconAfter
        ? _c("icon", { attrs: { name: _vm.icon, size: _vm.size } })
        : _vm._e(),
      _c("span", { staticClass: "u-sr-only" }, [_vm._v(_vm._s(_vm.label))]),
      _vm.icon && _vm.iconAfter
        ? _c("icon", { attrs: { name: _vm.icon, size: _vm.size } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }